<h2 mat-dialog-title>Attachments</h2>

<mat-dialog-content fxFlex="auto">
    <attachments-container [canEdit]="canEdit" [entityType]="entityType" [canAdd]="true" [model]="attachments" (delete)="onDelete($event)">
    </attachments-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <command-bar [commands]="commands">
    </command-bar>
</mat-dialog-actions>